import { forwardRef, type Ref, type SVGProps } from "react";
const IconReorderFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M12 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 18a3 3 0 1 0 0-6 3 3 0 0 0 0 6m8-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 18a3 3 0 1 0 0-6 3 3 0 0 0 0 6" /></svg>;
const ForwardRef = forwardRef(IconReorderFilledSVG);
ForwardRef.displayName = "IconReorderFilled";
export { ForwardRef as IconReorderFilled };